import { createSlice } from "@reduxjs/toolkit";

export const propertiesSlice = createSlice({
  name: "properties",
  initialState: {
    viewed_properties: [],
  },

  reducers: {
    setViewedProperty: (state, action) => {
      state.viewed_properties = action.payload;
    },

    clearViewedProperty: (state) => {
      state.viewed_properties = [];
    },
  },
});

export const { setViewedProperty, clearViewedProperty } =
  propertiesSlice.actions;

export default propertiesSlice.reducer;
